import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Newsgrid, Newsgrid2, Newsgrid3, Breaking, Videobox, SocialSharing, VideoPlayer } from '../components/Index';
import Tabs from '../components/Tabs';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from '../store/useSwipe';
import NewsTicker from '../components/NewsTicker';
import fetchData from 'Utilis/request';
import {HEADING_STYLE_DARK_MODE, HEADING_STYLE_LIGHT_MODE} from '../Config/config';
import { Link } from 'react-router-dom';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const HomePage = () => {
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
  const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
  const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);
  const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
  const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
  const activeCategory = useAppSelector((state:any) => state.categoryNavigation.activecategory);
  const settingLocalData = useAppSelector((state: any) => state.staticSettingSlice.data);

  const [activeTab, setActiveTab] = useState<string>('home');
  const [newsData, setNewsData] = useState<any>({});
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadedSections, setLoadedSections] = useState<number[]>([]);
  const newsContainerRef = useRef<HTMLDivElement>(null);
  
  const sections = [
    { type: 'latest', title: 'ताजा खबरें' },
    { type: 'video', title: 'वीडियो समाचार' },
    { type: 'india', title: 'भारत' },
    { type: 'sports', title: 'खेल' },
    { type: 'lifestyle', title: 'लाइफस्टाइल' },
    { type: 'astro', title: 'एस्ट्रो' },
    { type: 'business', title: 'बिजनेस' },
    { type: 'entertainment', title: 'मनोरंजन' },
    { type: 'religion', title: 'धर्म' },
    { type: 'tech_news', title: 'टेक ज्ञान' },
    { type: 'job', title: 'जॉब-बिजनेस' }
  ];

  const loadSection = async (sectionIndex: number) => {
    if (loading || loadedSections.includes(sectionIndex)) return;
    
    setLoading(true);
    const section = sections[sectionIndex];

    try {
      let data:any;
      if (section.type === 'latest') {
         data = await fetchData.getResult(`${API_BASE_URL}getArticleLatest.php`);
        setNewsData((prev:any) => ({ ...prev, latest: data?.articles || [] }));
      } 
      else if (section.type === 'video') {
        data = await fetchData.getResult(`${API_BASE_URL}getArticleByCat.php?slug=${'video'}&start=0`);
        setVideos(data?.articles || []);
      }
      else {
        data = await fetchData.getResult(`${API_BASE_URL}getArticleByCat.php?slug=${section.type}&start=0`);       
        setNewsData((prev:any) => ({ ...prev, [section.type]: data?.articles || [] }));
      }

      setLoadedSections(prev => [...prev, sectionIndex]);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const shouldFetchMore = () => {
    if (!newsContainerRef.current || loading) return false;
    const { scrollTop, scrollHeight, clientHeight } = newsContainerRef.current;
    return scrollTop + clientHeight >= scrollHeight - 100;
  };

  const handleScroll = useCallback(async () => {
    if (!shouldFetchMore()) return;    
    // Load next section that hasn't been loaded yet
    for (let i = 0; i < sections.length; i++) {
      if (!loadedSections.includes(i)) {
        await loadSection(i);
        break;
      }
    }
  }, [loadedSections, loading]);

  useEffect(() => {
    // Load first section initially
    loadSection(0);
  }, []);

  const renderSection = (sectionIndex: number) => {
    const section = sections[sectionIndex];
    const data = section.type === 'video' ? videos : newsData[section.type];

    if (!loadedSections.includes(sectionIndex) || !data || data.length === 0) {
      return null;
    }    

    return (
      <React.Fragment key={section.type}>
        <h2 className={`text-xl capitalize font-bold mb-2 ${darkMode ? HEADING_STYLE_DARK_MODE : HEADING_STYLE_LIGHT_MODE}`}>
          {section.title}
        </h2>
        
        {section.type === 'video' ? (
          <Videobox
            darkMode={darkMode}
            fontSize={fontSize}
            videos={data}
            inlineView={true}
          />
        ) : (
          data.map((news: any, index: number) => (
            index === 0 ? (
              <Newsgrid news={news} darkMode={darkMode} fontSize={fontSize} key={`${section.type}-${index}`} />
            ) : index % 3 !== 0 ? (
              <Newsgrid2 news={news} darkMode={darkMode} fontSize={fontSize} key={`${section.type}-${index}`} />
            ) : (
              <Newsgrid3 news={news} darkMode={darkMode} fontSize={fontSize} key={`${section.type}-${index}`} />
            )
          ))
        )}
      </React.Fragment>
    );
  };

useEffect(() => {
  const liveTvEl = document.querySelector(".home-livetv") as HTMLElement | null;
  const scrollContainer = newsContainerRef.current;

  if (!liveTvEl || !scrollContainer) return;

  const liveTvTop = liveTvEl.offsetTop;

  const handleLiveTvSticky = () => {
    const scrollPosition = scrollContainer.scrollTop;
    // if (scrollPosition >= 300) {
    //   liveTvEl.classList.add("fixed", `bottom-${fooNavHeight}`, "right-0", "z-50", "px-0","scale-50","origin-right");
    // } else {    
    //   liveTvEl.classList.remove("fixed", `bottom-${fooNavHeight}`, "right-0", "z-50", "px-0","scale-50","origin-right");
    // }
  };

  scrollContainer.addEventListener("scroll", handleLiveTvSticky);
  return () => {
    scrollContainer.removeEventListener("scroll", handleLiveTvSticky);
  };
}, []);

  return (
    <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>  
    {/* <Link className='fixed inset-0 z-10' to={'/testpage'}>testpage</Link>     */}
      <main
        className="home-container"
        ref={newsContainerRef}
        onScroll={handleScroll}
        style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>
      {/* Trending Topics Ticker */}
      <div className={`overflow-hidden mb-2`}>
{settingLocalData?.election_result_live && <div className=''> <Link to={'https://bharat24live.com/'} target='_blank'><img src={settingLocalData?.election_banner_home_page}/></Link></div>}
        <div className={`ticker-container relative overflow-hidden rounded ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}`}>          
          <Breaking darkMode={darkMode} />
        </div>
      </div>
        <div className="home-livetv px-3">
          {/* <VideoPlayer /> */}
          {/* https://cdn.ottlive.co.in/bharat24/embed.html */}
          <div className="w-full max-w-[1200px] mx-auto aspect-video overflow-hidden rounded-lg shadow">
            <iframe 
              src="https://stream1.ottlive.co.in/bharat24/embed.html" 
              allow="autoplay;fullscreen" 
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "8px"
              }}
              title="Live TV Stream"
            />
          </div>
        </div>


        <div className="news-container px-3">        
          <NewsTicker darkMode={darkMode} fontSize={fontSize} limit={5}/>
          {/* Render sections in exact order */}
          {sections.map((_, index) => renderSection(index))}
          {loadedSections.length === (sections.length+1) && (
            <p className="text-center py-4">No More Results Available</p>
          )}
        </div>
        <SocialSharing darkMode={darkMode}/>
      </main>     

      <Tabs
        activeTab={activeTab}
        darkMode={darkMode}
        fontSize={fontSize}
        loading={loading}
      />

    </div>
  );
};

export default HomePage;